import './App.css';
import GamePage from "./pages/game/page/game_page.js";
import WithdrawPage from "./pages/withdrawing/page/withdrawing_page.js";
import FriendsPage from './pages/friends/page/friends_page.js';
import NotificationProvider from './components/NotificationProvider.js';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SpinPage from './pages/spin/page/spin.js';
import { TadsWidgetProvider } from 'react-tads-widget';

function App() {
  return (
    <NotificationProvider>
      <TadsWidgetProvider>
        <Router>
          <Routes>
            <Route path="/" element={<GamePage />} />
            <Route path="/withdraw" element={<WithdrawPage />} />
            <Route path="/leaderboard" element={<FriendsPage />} />
            <Route path="/spin" element={<SpinPage />} />
          </Routes>
        </Router>
      </TadsWidgetProvider>
    </NotificationProvider>
  );
}

export default App;
